// =============================================
// 🔔 Composable Global de Toast — Click Sorvetes
// =============================================

import { reactive, inject, provide } from "vue";

// Identificador único do contexto (para evitar conflitos)
const ToastSymbol = Symbol("toast");

// Estado reativo global do toast
const state = reactive({
  visible: false,
  message: "",
  type: "info", // tipos possíveis: info | success | error | warning
});

// Função principal para exibir toasts
function showToast(message, type = "info", duration = 3000) {
  state.message = message;
  state.type = type;
  state.visible = true;

  // Fecha automaticamente após o tempo definido
  setTimeout(() => {
    state.visible = false;
  }, duration);
}

// ========================================================
// Provider — deve ser chamado **uma vez**, no layout global
// ========================================================
export function provideToast() {
  // Fornece o estado e a função global
  provide(ToastSymbol, {
    state,
    showToast,
  });

  // Também retorna o objeto para uso no próprio layout (opcional)
  return { state, showToast };
}

// ========================================================
// Hook de uso — pode ser chamado em qualquer componente filho
// ========================================================
export function useToast() {
  const toast = inject(ToastSymbol);

  if (!toast) {
    console.warn("⚠️ useToast() foi usado fora do contexto do provideToast()");
    // Retorna um objeto "neutro" para evitar crash se for chamado errado
    return {
      state: reactive({ visible: false, message: "", type: "info" }),
      showToast: () => {},
    };
  }

  return toast;
}
